<template>
  <div>
    <v-container>
      <div class="text-h5 font-weight-bold">
        家族（祖父母、外祖父母、父母、兄弟姐妹、兒女、叔伯姑姨）疾病史
      </div>
      <div class="d-flex flex-wrap">
        <div class="item-personal-record" v-for="key of 家族疾病史">
          <v-checkbox
            v-model="問卷['家族' + key]"
            :label="mapLabels(key)"
            hide-details
          ></v-checkbox>
        </div>
        <div class="item-personal-record">
          <v-checkbox label="無" hide-details></v-checkbox>
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import { 家族疾病史 } from "@/libs/const.js";
export default {
  name: "QuestionContent",
  props: ["valid", "person", "問卷"],
  data: () => ({ 家族疾病史 }),
  methods: {
    mapLabels(key) {
      if (key === "遺傳性非瘜肉大腸直腸癌") return "大腸癌或遺傳性息肉";
      return key;
    },
  },
};
</script>
<style lang="scss" scoped>
.item-personal-record {
  width: 160px;
  display: inline-block;
}
</style>
